import { ActionTree } from 'vuex'
import { identifySegmentUser } from 'vue-common/src/services/analytics/segment.service'

export const actions: ActionTree<unknown, unknown> = {
  async IDENTIFY_USER(_context, user) {
    identifySegmentUser(user)
  }
}
